import { createAction, props } from '@ngrx/store';
import { SettingsReducerInitialState } from '../reducers/settings.reducer';

const prefix = '[Settings]';

export const setStateAction = createAction(
  `${prefix} set state`,
  props<Partial<SettingsReducerInitialState>>()
);
